import React from 'react';

import './InfoBox.css';

const InfoBox = ({message, children}) => {
    return (
        <div className="info-box-container">
            <span className="info-box">
                {message}
                {children}
            </span>
        </div>
    );
}

export default InfoBox;



// WEBPACK FOOTER //
// ./src/components/InfoBox.js